import React, {useState, useEffect} from 'react';
import { useStaticQuery, graphql, Link } from "gatsby"
import { Helmet } from "react-helmet";
import { useLocation } from "@reach/router"

import Layout from "../components/Layout"
import { PageLinks } from "../common/page-links";
import { breadcrumbs } from "../common/utils/breadcrumbs";
import Journey from "../components/Journey/Journey";
import JobDetail from "../components/JobDetail/JobDetail";

import { ApiRequest } from "../common/utils/api_request_utils";

import _ from "lodash";

const JobDetailTemplate = () => {
  let brand_type = process.env.GATSBY_CAREER_BRAND || "dj-alexander";

  var { pathname } = useLocation()
  //console.log("pathname ==>", pathname);
  const[jobDetail, setJobDetail] = useState("");


  useEffect(() => {

    
      let url_split = pathname.split('/');
      let filter_url = url_split.filter(item => item != "");
      let slug = filter_url[filter_url.length - 1];

      //console.log("slug ==>", slug, filter_url)

      let career_api_url = `https://lomond-strapi.q.starberry.com/careers?slug=${slug}`;
      if(brand_type){
          career_api_url += `&brand=${brand_type}`
      }

      ApiRequest({
          method: "GET",
          url: career_api_url,
          header: {
              Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYzYmJjYzIxYjZhMzFjNjVmOGRiZTE4OCIsImlhdCI6MTY3NzE0MDE2NSwiZXhwIjoxOTkyNzE2MTY1fQ.EugjSp7GWcOVzSUJ-7N5bWEFXzS2hmq9xCPBRtUKuos`,
          }
      }, (result) => {
          if (result.length > 0) {
            setJobDetail(result[0])
            setLoading(true)
          }
      })
      
  }, []);


  const bread = [
    { label: 'Careers', slug: PageLinks.careers }, 
    { label: 'Current Vacancies', slug: PageLinks.current_vacancies }, 
    { label: jobDetail?.title, slug: ""}
  ]
  const breadcrumbsList = breadcrumbs(null, bread);

  var meta_title = jobDetail?.title;
  var meta_desc = meta_title
  
  return (
    // loading ? 
    //   <PreLoader />
    // :
    <div className="search-header property-header job_detail news-detail-page">
      {meta_title &&
      <Layout 
        seo_meta={{
          title: meta_title,
          description: meta_desc,
        }}
        menu_slug={"job-detail"}
      >
        <JobDetail data={jobDetail} breadcrumbs={breadcrumbsList} />

        <Journey />

      </Layout>
      }
    </div>
  )

}

export default JobDetailTemplate